<template>
    <div>
        <div class="flex justify-around p-8">
            <span>
                {{ $t('labels.routing') }}
                <span class="text-error-500">
                    *
                </span>
            </span>
            <input-routing
                :routing-info="routingInfo"
                @change="(data: any) => handleChange(data)" />
        </div>
        <p
            class="absolute right-20 text-blue-300 cursor-pointer"
            @click="handleClickOpenGoogleMap">
            Mở bằng google map
        </p>

        <div class="absolute right-20 bottom-10">
            <hts-form-button
                icon-name="hi-arrow-right-icon"
                icon-position="right"
                color="primary"
                @click="handleClick">
                {{ $t('labels.nextScreen') }}
            </hts-form-button>
        </div>
    </div>
</template>
<script setup lang="ts">
import InputRouting from '../component/input-routing.vue'

const props = defineProps({
  routingInfo: {
    type: Array<Object>,
    default: () => []
  }
})
const emits = defineEmits(['click'])
const routingData = ref([...props.routingInfo])
const handleChange = (data: any) => {
  routingData.value = data
}
const handleClick = () => {
  const checkEmpty = routingData.value.find((item: any) => item.nodeId === '' || item.nodeName === '')
  if (checkEmpty || !routingData.value.length) {
    return $toast().error($t('validations.emptyRouting'))
  }
  emits('click', routingData.value)
}
const handleClickOpenGoogleMap = () => {
  emits('click', [])
}
</script>
